<template lang="pug">
#modal-historico-operacao
    el-dialog.cabecalho(
        width='700px',
        :title="$t('mensagens.operacao.visualizar.historico.titulo')",
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        section(v-loading='carregandoTabelaBaseDados')
            el-table(
                :data='baseDados',
                style='width: 100%'
            )
                el-table-column(
                    :label='$t("mensagens.operacao.visualizar.historico.acao")'
                )
                    template(slot-scope='scope')
                        span.celula {{ obterLabelAcao(scope.row.acao) }}

                el-table-column(
                    :label='$t("mensagens.operacao.visualizar.historico.data")'
                )
                    template(slot-scope='scope')
                        span.celula {{ scope.row.dataRegistroFormatada }}

                el-table-column(
                    :label='$t("mensagens.operacao.visualizar.historico.usuario")'
                )
                    template(slot-scope='scope')
                        span.celula {{ scope.row.nomeUsuario }}
                        
                el-table-column(
                    :label='$t("mensagens.operacao.visualizar.historico.empresa")'
                )
                    template(slot-scope='scope')
                        span.celula {{ scope.row.nomeEmpresa }}

                el-table-column(
                    :label='$t("mensagens.operacao.visualizar.historico.pdf")',
                    width='80',
                    align='center'
                )
                    template(slot-scope='scope')
                        el-tooltip(
                            v-if='scope.row.possuiPdf',
                            :content='$t("mensagens.operacao.visualizar.historico.baixarPdf")',
                            placement='top'
                        )
                            el-button(
                                type='primary',
                                size='mini',
                                icon='el-icon-download',
                                circle,
                                @click='baixarPdf(scope.row.idAnalise)'
                            )

        .botoes
            BaseButton(@click='fechar') {{ $t('mensagens.comuns.voltar') }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import OperacaoService from '@/services/OperacaoService';
export default {
    name: 'ModalVisualizarHistorico',
    components: {
        BaseButton
    },
    props: {
        idOperacao: {
            type: Number,
            required: true
        },
        mostrar: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            baseDados: [],
            carregandoTabelaBaseDados: false
        };
    },
    mounted() {
        this.tabelaBaseDados();
    },
    methods: {
        async tabelaBaseDados() {
            try {
                this.carregandoTabelaBaseDados = true;
                const { data } = await OperacaoService.listarHistorico(this.idOperacao);
                this.baseDados = data;
            } finally {
                this.carregandoTabelaBaseDados = false;
            }
        },
        fechar() {
            this.$emit('fechar');
        },
        obterLabelAcao(acao) {
            if (acao === 'AGUARDANDO_APROVACAO') {
                return this.$t('mensagens.operacao.visualizar.historico.acaoCadastro');
            }
            return this.$t(`mensagens.operacao.${acao}`);
        },
        async baixarPdf(idAnalise) {
            try {
                await OperacaoService.downloadPdfAprovacao(idAnalise);
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.visualizar.historico.erroDownloadPdf')
                });
            }
        }
    }
};
</script>

<style lang="scss">
#modal-historico-operacao {
    div.el-dialog__wrapper.cabecalho div div.el-dialog__header {
        padding-bottom: 10px !important;
        background-color: var(--default-background-color);
        .el-dialog__title {
            font-weight: 600;
            color: var(--primary);
        }
    }

    .el-table th {
        font-weight: bold !important;
    }

    .celula {
        display: block;
        width: 100%;
    }
}

.botoes {
    display: flex;
    justify-content: space-between;
    padding-top: 25px;
    gap: 10px;
}
</style>
